import React from 'react';
import { FormatCurrency } from './format-currency';

interface ComponentProps {
  currency?: string | null;
  showCurrencyCode?: boolean;
  value?: number | string;
  showCommas?: boolean;
  enableCurrencyBasedDenomination?: boolean;
}

const FormattedCurrencyV2 = ({
  showCurrencyCode = false,
  value,
  currency,
  showCommas = true,
  enableCurrencyBasedDenomination = false,
}: ComponentProps) => {
  // to replace FormattedCurrencyV2 with FormatCurrency at mulitple places and imports adding it one place
  return (
    <FormatCurrency
      showCurrencyCode={showCurrencyCode}
      showCommas={showCommas}
      currency={currency}
      value={value}
      enableCurrencyBasedDenomination={enableCurrencyBasedDenomination}
    />
  );
};

export default FormattedCurrencyV2;
